import styles from './template.css';
import template from './template';
import {AoflElement, customElement} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '@modules/i18n';

/**
 * @summary UnsavedChangesConfirmation
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('unsaved-changes-confirmation')
class UnsavedChangesConfirmation extends i18nMixin(AoflElement) {
  /**
   * @readonly
   */
  static is = 'unsaved-changes-confirmation';

  /**
   * Creates an instance of UnsavedChangesConfirmation.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }

  back() {
    this.dispatch(false);
  }

  proceed() {
    this.dispatch(true);
  }

  dispatch(proceed) {
    this.dispatchEvent(new CustomEvent('submit', {
      detail: {
        proceed
      }
    }));
  }
}

export default UnsavedChangesConfirmation;
